import { useNavigate } from 'react-router-dom';

import React from 'react'
import { TiWeatherPartlySunny } from "react-icons/ti";
import { CgProfile } from "react-icons/cg";
import { GrMoney } from "react-icons/gr";
import { BsCart4 } from "react-icons/bs";

const Navigation = () => {
  const navigate = useNavigate();

  return (
    <div className='navigation-pane'>
      <div className='navigation-items'>
        <span className='content-item' onClick={() => navigate('/skincare')}>skin care</span>
        <span className='content-item' onClick={() => navigate('/makeup')}>makeup</span>
        <span className='content-item' onClick={() => navigate('/wellness')}>wellness</span>
      </div>
      <div className='side-tabs'>
      <div className='cart-icon' onClick={() => navigate('/cart')}><BsCart4 /></div>
      <div className='profile-icon' onClick={() => navigate('/profile')}><CgProfile /></div>
      <div className='currency-icon' onClick={() => navigate('/currency')}><GrMoney /></div>
      <div className='weather-icon' onClick={() => navigate('/weather')}><TiWeatherPartlySunny /></div>
      </div>
    </div>
  )
}

export default Navigation